import { Button, Modal, Table } from 'antd';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Tabs } from 'antd';
import columns from './columns';
import ModalContent from '../../../../../../components/MeassureModalContent';
import { useLocation } from 'react-router';
import { renderObjective, renderStatus } from '../../../../../Analysis/scl-widgets/corrective-measures/helper';
import { isProxy } from 'datastake-daf/src/helpers/Token';
import { ModalHeader } from 'datastake-daf/dist/components';
import { getLocales } from '../../../../../../components/Table/newTable';

const mode = isProxy() ? 'proxy' : 'app';

const { TabPane } = Tabs;

const Style = styled.div`
  .ant-table {
    margin-bottom: 13px;
  }

  .rm-header {
    display: flex;
    margin-bottom: 42px;

    .cont {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;

      h1 {
        margin-bottom: 0px;
      }
    }

    .ant-btn {
      svg {
        margin-top: -4px;
      }
    }
  }

  .icon-btn {
    border-color: var(--mmt-primary-70);
    color: var(--mmt-primary-70);

    svg {
      margin-top: -4px;
      color: var(--mmt-primary-70);
    }
  }
`;

const tabs = [
  {
    key: 'proposed',
    label: 'Proposed',
  },
  {
    key: 'inProgress',
    label: 'In Progress',
  },
  {
    key: 'completed',
    label: 'Completed',
  },
];

export default function RiskMitigationMeasures({
  data = [],
  canEdit = false,
}) {
  const { t } = useTranslation();
  const [activeMitigation, setActiveMitigation] = useState(null);
  const path = useLocation();

  const values = useMemo(() => {
    const proposed = [];
    const inProgress = [];
    const completed = [];

    if (Array.isArray(data)) {
      data.forEach((d) => {
        if (typeof d.completedAt === 'string') {
          completed.push(d);
        } else if (d.events.length) {
          inProgress.push(d);
        } else {
          proposed.push(d);
        }
      })
    }
    return { proposed, inProgress, completed };
  }, [data]);

  const actions = useMemo(() => ({
    setActiveMitigation: (val) => {
      let status = 'proposed';
      if (typeof val.completedAt === 'string') {
        status = 'completed';
      } else if ((val.events || []).length) {
        status = 'inProgress';
      }
      setActiveMitigation({ ...val, status });
    },
  }), []);

  return (
    <Style>
      <Modal
        open={!!activeMitigation}
        width={888}
        title={(
          <ModalHeader
            title={activeMitigation ? activeMitigation.title : ''}
          />
        )}
        className="rec-modal"
        destroyOnClose
        onCancel={() => setActiveMitigation(null)}
        footer={[
          <>
            {(activeMitigation && canEdit) && (
              <>
                {mode === 'app' ? (
                  <a
                    target="_blank"
                    href={`${path.pathname.replace(/view/, 'edit')}/planning`}
                    rel="noreferrer"
                  >
                    <Button type="primary">
                      {t('Edit')}
                    </Button>
                  </a>
                ) : (
                  <a href={`${path.pathname.replace(/view/, 'edit')}/planning`}>
                    <Button type="primary">
                      {t('Edit')}
                    </Button>
                  </a>
                )}
              </>
            )}
          </>
        ]}
      >
        {activeMitigation && (
          <ModalContent
            rec={activeMitigation}
            actions={{
              renderStatus,
              renderObjective,
            }}
            informationSource={activeMitigation.informationSource || undefined}
            layout="LAYOUT_B"
            t={t}
          />
        )}
      </Modal>
      <Tabs defaultActiveKey={tabs[0].key}>
        {tabs.map((tab) => (
          <TabPane
            tab={`${t(tab.label)}(${(values[tab.key] || []).length})`}
            key={tab.key}
          >
            <Table
              size="small"
              locale={getLocales(t)}
              dataSource={values[tab.key]}
              columns={columns(actions, t)[tab.key]}
              pagination={false}
            />
          </TabPane>
        ))}
      </Tabs>
    </Style>
  );
}
